import { render } from "./ChatAdPurchaseView.vue?vue&type=template&id=1cbecf40&scoped=true"
import script from "./ChatAdPurchaseView.vue?vue&type=script&lang=js"
export * from "./ChatAdPurchaseView.vue?vue&type=script&lang=js"

import "./ChatAdPurchaseView.vue?vue&type=style&index=0&id=1cbecf40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbecf40"]])

export default __exports__